/**
 * Custo real da integração de NF-e de entrada.
 *
 * Frete, seguro e outras despesas: rateio pelo vProd total da nota
 * (inclui freteTipo=1 / CT-e). Desconto e IPI: valor do próprio item
 * (XML/backend). IBS/CBS não entram neste cálculo.
 */

function toNumber(val) {
    if (val === null || val === undefined || val === "") {
        return 0;
    }
    const num = parseFloat(String(val).replace(",", "."));
    return Number.isNaN(num) ? 0 : num;
}

function ratearDespesa(vProd, vDespesa, vItem) {
    const total = toNumber(vDespesa);
    if (total === 0) {
        return 0;
    }
    const razao = (toNumber(vProd) + total) / toNumber(vProd);
    return toNumber(vItem) * razao - toNumber(vItem);
}

function applyHeaderRateios(det, vProdTotal, header) {
    det.vFrete = ratearDespesa(vProdTotal, header.vFrete, det.vProd);
    det.vSeg = ratearDespesa(vProdTotal, header.vSeg, det.vProd);
    det.vOutro = ratearDespesa(vProdTotal, header.vOutro, det.vProd);
    return det;
}

function computeCustoAtual(det) {
    const qCom = toNumber(det.qCom || 1);
    const vProd = toNumber(det.vProd);
    const vFrete = toNumber(det.vFrete);
    const vSeg = toNumber(det.vSeg);
    const vOutro = toNumber(det.vOutro);
    const vIPI = toNumber(det.vIPI);
    const vDesc = toNumber(det.vDesc);
    const vICMSST = toNumber(det.vICMSST);

    let vCustoSemIcms = vProd + vFrete + vSeg + vOutro + vIPI - vDesc;
    vCustoSemIcms = vCustoSemIcms / qCom;
    const icmsUnit = vICMSST / qCom;
    return (vCustoSemIcms + icmsUnit).toFixed(3);
}

function recalculaItensCusto(dets, totals, options) {
    const vProdTotal = toNumber(totals.vProd);
    const vFrete =
        String(options && options.freteTipo) === "1"
            ? toNumber(options.vFrete)
            : 0;
    const header = {
        vFrete: vFrete,
        vSeg: toNumber(totals.vSeg),
        vOutro: toNumber(totals.vOutro),
    };

    return dets.map(function (det) {
        const next = Object.assign({}, det);
        applyHeaderRateios(next, vProdTotal, header);
        next.vCustoAtual = computeCustoAtual(next);
        return next;
    });
}

module.exports = {
    toNumber: toNumber,
    ratearDespesa: ratearDespesa,
    applyHeaderRateios: applyHeaderRateios,
    computeCustoAtual: computeCustoAtual,
    recalculaItensCusto: recalculaItensCusto,
};
